import { apiBaseUrlUser } from "../../../constants/url.constant";

function AppLink() {
    const handleDownload = () => {
        fetch(apiBaseUrlUser + "/appleApp/getFile")
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download = "apple-app-site-association.json" || "downloaded-file.json";
                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    };

    handleDownload();

    return (
        <div>

        </div>
    );
}

export default AppLink;